export interface ICandidateSignatures {
	referenceCheckConsentSignature?: string;
	safeInEducationCheckConsentSignature?: string;
	healthRecordCheckConsentSignature?: string;
	declarationCheckConsentSignature?: string;
	contractForServiceSignature?: string;
	criminalRecordCheckConsentSignature?: string;
}

export class CandidateSignaturesModel implements ICandidateSignatures {
	referenceCheckConsentSignature?: string;
	safeInEducationCheckConsentSignature?: string;
	healthRecordCheckConsentSignature?: string;
	declarationCheckConsentSignature?: string;
	contractForServiceSignature?: string;
	criminalRecordCheckConsentSignature?: string;

	constructor(data?: ICandidateSignatures) {
		this.referenceCheckConsentSignature = data?.referenceCheckConsentSignature;
		this.safeInEducationCheckConsentSignature = data?.safeInEducationCheckConsentSignature;
		this.healthRecordCheckConsentSignature = data?.healthRecordCheckConsentSignature;
		this.declarationCheckConsentSignature = data?.declarationCheckConsentSignature;
		this.contractForServiceSignature = data?.contractForServiceSignature;
		this.criminalRecordCheckConsentSignature = data?.criminalRecordCheckConsentSignature;
	}
}
